module.exports = __webpack_public_path__ + "static/media/how_to_migrate_from_js_to_ts.369bfc82.gif";